// Only used for production builds
require('@mymedsandme/reportum-ui/dist/main.js')
